// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .dark-layout .bg-instagram {\r\n  background-color: #8134af;\n}\n[dir] .btn-instagram {\r\n  background-color: #dd2a7b;\n}\n[dir] .dark-layout .bg-linkedin {\r\n  background-color: #0a66c2;\n}\n[dir] .btn.btn-black {\r\n  background-color: #000000;\n}\n.b-avatar.avatar-description {\r\n  width: 5rem;\r\n  height: 5rem;\n}\n.small-datepicker {\r\n  width: 120px !important;  /* Reduce width */\r\n  font-size: 12px;  /* Adjust text size */\n}\r\n", ""]);
// Exports
module.exports = exports;
